export function useMatchData(match) {
    const matchId = ref();
    const companyRef = ref();
    const isAnonymous = ref();
    const isLocal = ref();
    const isInterstate = ref();
    const isOrganic = ref();
    const isMuvexpress = ref();
    const isSelfPack = ref();
    const isSelfy = ref();
    const isBookable = ref();
    const isTaxibox = ref();
    const isCustom = ref();
    const isTender = ref();
    const isLane = ref();
    const isTrip = ref();
    const isFixed = ref();
    const isVariable = ref();
    const isVisible = ref();
    const isPremium = ref();
    const reviewPricing = ref();
    const moveType = ref();
    const moveId = ref();
    const matchType = ref();
    const companyName = ref();
    const companyId = ref();
    const companyCount = ref();
    const logoUrl = ref();
    const inputPrice = ref();
    const pricePerUnit = ref();
    const quotedSpace = ref();
    const spaceTotal = ref();
    const companyTotal = ref();
    const surcharge = ref();
    const extraSurcharge = ref();
    const bundlesCost = ref();
    const muvalFee = ref();
    const bookingFee = ref();
    const rating = ref();
    const reviewCount = ref();
    const estimatedTotal = ref();
    const minPrice = ref();
    const travelEst = ref();
    const travelFee = ref();
    const matchableType = ref();
    const matchableId = ref();
    const matchableFormatted = ref();
    const matchableIdFormatted = ref();
    const routeDeliveryTimeframe = ref();
    const bundles = ref();
    const minHours = ref();
    const order = ref();
    const companyNotes = ref();
    const createdAt = ref();
    const expiresAt = ref();
    const quantity = ref();

    // formatted dates
    const pickupDateFormatted = ref();
    const deliveryDateFormatted = ref();

    function execute() {
        let data = unref(match);

        companyRef.value = data?.company_ref;
        order.value = data?.order;

        console.log('useMatchData', data);

        // Boolean checks
        isAnonymous.value = data?.anonymous;
        isLocal.value = data?.move_type == 'LOCAL';
        isInterstate.value = data?.move_type == 'INTERSTATE';
        isOrganic.value = data?.match_type == 'ORGANIC';
        isMuvexpress.value = data?.match_type == 'MUVEXPRESS';
        isSelfPack.value = data?.match_type == 'SELF_PACK';
        isSelfy.value = data?.is_selfy;
        isBookable.value = data?.is_bookable;
        isTaxibox.value = data?.is_taxibox;
        isCustom.value = data?.match_type == 'CUSTOM';
        isTender.value = data?.match_type === 'TENDER';
        isLane.value = data?.matchable_type == 'lane';
        isTrip.value = data?.matchable_type == 'trip';
        isFixed.value = data?.pricing_type == 'FIXED';
        isVariable.value = data?.pricing_type == 'VARIABLE';
        isVisible.value = data?.visible;
        isPremium.value = data?.premium;

        // Getters
        matchId.value = data?.id;
        moveType.value = data?.move_type;
        moveId.value = data?.move_id;
        matchType.value = data?.match_type;
        companyName.value = data?.company?.name;
        companyId.value = data?.company?.id;
        companyCount.value = data?.company_count;
        logoUrl.value = data?.company?.logo;
        pricePerUnit.value = data?.price_per_unit?.formatted;
        quotedSpace.value = data?.quoted_space;
        rating.value = data?.company?.rating;
        reviewCount.value = data?.company?.review_count;
        estimatedTotal.value = data?.estimated_total?.formatted;
        inputPrice.value = data?.input_price?.formatted;
        minPrice.value = data?.min_price?.formatted;
        travelEst.value = data?.travel_time_formatted;
        travelFee.value = data?.travel_fee?.formatted;
        matchableType.value = data?.matchable_type;
        matchableId.value = data?.matchable_id;
        matchableFormatted.value = handleMatchableType(data?.matchable_type, data?.matchable);
        matchableIdFormatted.value = handleMatchableId(data?.matchable_type, data?.matchable);
        minHours.value = data?.min_hours;
        routeDeliveryTimeframe.value = data?.matchable?.route_delivery_timeframe;
        bundles.value = data?.bundles;
        spaceTotal.value = data?.space_total?.formatted;
        companyTotal.value = data?.company_total?.formatted;
        surcharge.value = data?.surcharge?.formatted;
        extraSurcharge.value = data?.extra_surcharge?.formatted;
        bundlesCost.value = data?.bundles_cost?.formatted;
        muvalFee.value = data?.muval_fee?.formatted;
        bookingFee.value = data?.booking_fee?.formatted;
        reviewPricing.value = data?.review_pricing;
        companyNotes.value = data?.company_notes;
        createdAt.value = data?.created_at;
        expiresAt.value = data?.expires_at;
        quantity.value = handleQuantity(data);

        // Dates
        pickupDateFormatted.value = (() => {
            if (isLane.value) {
                return `${data?.min_pickup_date_formatted}${
                    (
                        data?.max_pickup_date_formatted &&
                        data?.max_pickup_date_formatted !== data?.min_pickup_date_formatted
                    ) ?
                        ` - ${data?.max_pickup_date_formatted}`
                    :   ''
                }`;
            } else if (isCustom.value || isTender.value) {
                return `${data?.min_pickup_date_formatted}${
                    (
                        data?.max_pickup_date_formatted &&
                        data?.max_pickup_date_formatted !== data?.min_pickup_date_formatted
                    ) ?
                        ` - ${data?.max_pickup_date_formatted}`
                    :   ''
                }`;
            } else {
                return data?.max_pickup_date_formatted ?
                        data?.max_pickup_date_formatted
                    :   data?.min_pickup_date_formatted;
            }
        })();

        deliveryDateFormatted.value = (() => {
            if (isLane.value && !isCustom.value) {
                return data?.max_delivery_string;
            } else if (isCustom.value || isTender.value) {
                if (data?.delivery_date_flexibility_formatted) {
                    return data?.delivery_date_flexibility_formatted;
                }

                return `${data?.min_delivery_date_formatted}${
                    (
                        data?.max_delivery_date_formatted &&
                        data?.max_delivery_date_formatted !== data?.min_delivery_date_formatted
                    ) ?
                        ` - ${data?.max_delivery_date_formatted}`
                    :   ''
                }`;
            } else {
                return data?.max_delivery_date_formatted ?
                        data?.max_delivery_date_formatted
                    :   data?.min_delivery_date_formatted;
            }
        })();
    }

    watch(match, execute, {
        deep: true,
        immediate: true,
    });

    return {
        matchId,
        companyRef,
        order,
        isAnonymous,
        isLocal,
        isInterstate,
        isOrganic,
        isMuvexpress,
        isSelfPack,
        isSelfy,
        isTaxibox,
        isBookable,
        isCustom,
        isTender,
        isLane,
        isTrip,
        isFixed,
        isVariable,
        isVisible,
        isPremium,
        moveType,
        moveId,
        matchType,
        companyName,
        companyId,
        companyCount,
        logoUrl,
        pricePerUnit,
        quotedSpace,
        inputPrice,
        rating,
        reviewCount,
        estimatedTotal,
        minPrice,
        travelEst,
        travelFee,
        matchableType,
        matchableId,
        matchableFormatted,
        matchableIdFormatted,
        routeDeliveryTimeframe,
        bundles,
        minHours,
        pickupDateFormatted,
        deliveryDateFormatted,
        spaceTotal,
        companyTotal,
        surcharge,
        extraSurcharge,
        bundlesCost,
        muvalFee,
        bookingFee,
        reviewPricing,
        companyNotes,
        createdAt,
        expiresAt,
        quantity,
    };

    // helper functions
    function handleMatchableType(matchable_type, matchable) {
        switch (matchable_type) {
            case 'trip':
                return 'Trip';
            case 'lane':
                return 'Lane';
            case 'move_custom_quote':
                return 'Custom';
            case 'move_taxibox_quote':
                return 'TAXIBOX';
            case 'move_selfy_estimate':
                return 'Selfy';
            case 'move_tender':
                return 'Tender';
            case 'depot':
                return matchable?.localPrices?.id ? 'Local' : 'Depot';
            case 'muvexpress_depot':
                return 'MuvExpress Depot';
        }
    }

    function handleMatchableId(matchable_type, matchable) {
        return matchable_type === 'depot' && matchable?.localPrices?.id ? matchable.localPrices.id : matchable?.id;
    }

    function handleQuantity(match) {
        if (match?.is_selfy) {
            return (match.matchable?.small_container_count ?? 0) + (match.matchable?.large_container_count ?? 0);
        }

        if (match?.is_taxibox) {
            return match.matchable?.box_count;
        }

        return 0;
    }
}
